export default __webpack_public_path__ + "static/media/mathwallet.e2475182.svg";